<template>
<div>
    <el-row>
        <el-col>
            <el-form :inline='true'>
                <el-form-item label="关键字：" >
                    <el-input placeholder="请输入试卷名称" v-model="filters.keyWord" clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
                </el-form-item>
            </el-form>
        </el-col>
    </el-row>
    <!-- 列表 -->
    <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="listLoading"
        @current-change='currentChange'
        :highlight-current-row='true'
        :header-row-style="{height: '47px'}"
        :cell-style="rowClass"
    >
        <el-table-column type='index' label="序号" width='60' align="center"></el-table-column>
        <el-table-column prop="PaperName" label="试卷名称" min-width="170" align="center"></el-table-column>
        <el-table-column prop="Score" label="试卷总分（分）" min-width="130" align="center"></el-table-column>
        <el-table-column prop="ExamDuration" label="考试时长（分钟）" min-width="140" align="center"></el-table-column>
        <el-table-column prop="PassScoreLine" label="及格分（分）" min-width="120" align="center"></el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar" style="height: 80px;margin-top: 12px">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageIndex"
            :page-sizes="pages.pageArr"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.dataCount"
        >
        </el-pagination>
    </el-col>
    <!--编辑-->
    <el-dialog
        :title="'编辑'"
        :visible.sync="paperDialog"
        v-model="paperDialog"
        :close-on-click-modal="false"
        width="65%"
    >
        <el-form
            :model="paperForm"
            label-width="200px"
            :rules="paperRules"
            ref="paperRef"
        >
            <el-form-item label="试卷名称:">
                {{paperForm.paperName}}
            </el-form-item>
            <el-form-item label="考试时长:" prop="examTimer">
                <el-input v-model="paperForm.examTimer" placeholder="请输入考试时长" onkeyup="value=value.replace(/[^\d\.]/g,'')" clearable style="width: 380px;"></el-input>
            </el-form-item>
            <el-form-item label="及格分:" prop="passScore">
                <el-input v-model="paperForm.passScore" placeholder="请输入及格分" onkeyup="value=value.replace(/[^\d\.]/g,'')" clearable style="width: 380px;"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="paperDialog = false">取消</el-button>
            <el-button type="primary" @click.native="paperSubmit" :loading="paperLoading">提交</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {getExamPaperInfoInternalSettingListPage,saveExamPaperInfoInternalSetting} from '@/api/api'
export default {
	components:{Toolbar},
	data() {
		return {
			buttonList: [],
			filters:{
                keyWord: "",
			},
            // 列表
            listLoading: false,
			tableData: [],
            currentRow: '',
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
            // 编辑
            paperDialog: false,
            paperLoading: false,
            paperForm: {
                paperName: "",
                examTimer: "",
                passScore: "",
            },
            paperRules: {
                examTimer: [{ required: true, message: "请输入考试时长", trigger: "blur" }],
                passScore: [{ required: true, message: "请输入及格分", trigger: "blur" }],
            },
		}
	},
	methods: {
		callFunction(item) {
			this[item.Func].apply(this, item);
		},
		getDataList(){
            let params = {
                paperName: this.filters.keyWord,
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
			}
            this.listLoading = true
			getExamPaperInfoInternalSettingListPage(params).then(res => {
				var result = res.data
				if(result.Success){
					this.tableData = result.Response.Data
					this.pages.dataCount = result.Response.DataCount
				}else{
                    this.tableData = []
                    this.pages.dataCount = 0
                }
                this.listLoading = false
			})
		},
		// 查询
		getTableData() {
			this.pages.pageIndex = 1
			this.getDataList();
		},
        // 编辑
        handleEdit() {
            if(!this.currentRow) {
                this.$message.warning("请先选择要编辑的数据！")
                return
            }
            this.paperDialog = true
            this.paperLoading = false
            this.paperForm = {
                paperName: this.currentRow.PaperName,
                examTimer: this.currentRow.ExamDuration,
                passScore: this.currentRow.PassScoreLine,
            }
        },
        // 编辑提交
        paperSubmit() {
            this.$refs.paperRef.validate((valid) => {
				if (valid) {
                    var params = {
                        paperId: this.currentRow.PaperId,
                        examDuration: this.paperForm.examTimer,
                        passScoreLine: this.paperForm.passScore,
                    }
                    this.paperLoading = true
                    saveExamPaperInfoInternalSetting(params).then(res => {
                        var result = res.data
                        if(result.Success) {
                            this.$message.success(result.Message)
                            this.paperDialog = false
                            this.getDataList()
                        } else {
                            this.$message.error(result.Message)
                        }
                        this.paperLoading = false
                    })
                }
            })
        },
		// 点击table某一行
		currentChange(val) {
			this.currentRow = val
		},
		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row.CreateTime || row.CreateTime == ""
            ? ""
            : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
		},
		formatCreateTimeDay1: function(row, column) {
			return !row || row == ""
            ? ""
            : util.formatDate.format(new Date(row), "yyyy-MM-dd");
		},
		rowClass(){
			return 'padding: 10px 0!important;'
		},
	},
	mounted() {
		let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getDataList()
	}
}
</script>

<style lang="stylus" scoped>

</style>
